export interface EQCompanyData {
  uid: number;
  guid: string;
  companyUID: number;
  changeRequestTip1: string; // 변경구분 설명
  changeRequestTip2: string; // 변경등급 설명
  changeGuideFile: string; // 변경판단 기준 파일명
  userManual: string;
  base64: string;
}

export const initializeCompanyData = () => {
  return {
    uid: 0,
    guid: "00000000-0000-0000-0000-000000000000",
    companyUID: 0,
    changeRequestTip1: "",
    changeRequestTip2: "",
    changeGuideFile: "",
    userManual: "",
    base64: "",
  };
};
